import accordions from './components/accordions';
import dialogs from './components/dialogs';
import footerMenus from "./components/footer-menus";
import logos from './components/logos';
import navigation from './components/navigation'
import responsiveToggle from './components/responsive-toggle'
import skipLinks from './components/skip-links';
import swiper from './components/swiper'
import tables from './components/tables';
import tabs from './components/tablist';
import Video from './components/video';
import cookieBotLinks from './components/cookiebot'

accordions( document.querySelectorAll( '.accordion' ) );

dialogs( document.querySelectorAll( '[data-open-dialog]' ), document.querySelectorAll( '[data-close-dialog]' ), document.querySelectorAll( '[data-dialog]' ) );

footerMenus( document.querySelectorAll( '.footer__section' ) );
logos(document.querySelectorAll('.logos__list'));
navigation( document.querySelector( '.header__nav' ) );

responsiveToggle( document.querySelector( '.responsive-toggle' ) );

skipLinks( document.getElementById( 'skip-to-content' ) );

swiper('.swiper');

// document.querySelectorAll(`[class*="swiper-custom"]`).forEach((el, index) => {
//   var myClass = el.getAttribute('class').split(" ");
//   swiper(`.${myClass.filter((className) => className.includes('swiper-custom'))[0]}`);
// });

tables( document.querySelectorAll( 'table' ) );

tabs( document.querySelectorAll( '.tabs' ) );
new Video();

cookieBotLinks();
